import ExistingFranchiseCosts from "./ExistingFranchiseCosts.svg";

export default ExistingFranchiseCosts;
